// eslint-disable-next-line import/prefer-default-export
export const INSERT_PETS = 'pet/insert'
export const DELETE_PET = 'pet/deletePet'
export const UPDATE_PET = 'pet/updatePet'
